import { Fragment } from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  RadioGroup,
  Radio,
  useTheme,
} from '@mui/material';
import SectionTitle from '../../components/SectionTitle';
import { IFormValues, IFormWatch } from 'routes/Main/type';
import useTableForm from '../../hooks/useTableForm';
import MuiRadioGroupSub from './MuiRadioGroupSub';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const BDIContents = (props: Props) => {
  const { palette } = useTheme();

  const { radioGroup, sumValues } = useTableForm(props);
  const { disabled, watch, setValue, getValues } = props;

  const titles = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
  ];

  const answers = [
    [
      '我现在不感到难过。',
      '我感到难过。',
      '我一直都很难过，无法摆脱这种感觉。',
      '我非常难过和痛苦，难以忍受。',
    ],
    [
      '我对未来并不特别感到沮丧。',
      '我对未来感到沮丧。',
      '我觉得没有什么值得期待的事情。',
      '我觉得前途无望，事情不会变好。',
    ],
    [
      '我不觉得自己是个失败者。',
      '我觉得我比一般人更失败。',
      '回顾我的人生，我看到的都是失败。',
      '我觉得自己是个彻底的失败者。',
    ],
    [
      '我像以前一样能从事物中获得满足感。',
      '我不像以前那样享受事物。',
      '我已经无法从任何事情中获得真正的满足。',
      '我对一切都感到不满意或厌烦。',
    ],
    [
      '我并不特别感到内疚。',
      '我大部分时间都感到内疚。',
      '我大多数时间感到非常内疚。',
      '我一直感到内疚。',
    ],
    [
      '我不觉得自己正在受惩罚。',
      '我觉得我可能会被惩罚。',
      '我预期自己会被惩罚。',
      '我觉得我正在被惩罚。',
    ],
    [
      '我不对自己感到失望。',
      '我对自己感到失望。',
      '我对自己感到厌恶。',
      '我讨厌自己。',
    ],
    [
      '我不觉得自己比别人差。',
      '我因自己的弱点或错误而责备自己。',
      '我总是为自己的过错责怪自己。',
      '我把所有不好的事情都归咎于自己。',
    ],
    [
      '我没有想过自杀。',
      '我有自杀的想法，但不会付诸行动。',
      '我想自杀。',
      '如果有机会，我会自杀。',
    ],
    [
      '我没有比平时更容易哭泣。',
      '我现在比以前更容易哭泣。',
      '我现在总是哭。',
      '我以前能哭，但现在即使想哭也哭不出来。',
    ],
    [
      '我对事物的烦躁程度没有增加。',
      '我现在比平时稍微更容易烦躁。',
      '我经常感到烦躁或恼火。',
      '我总是感到烦躁。',
    ],
    [
      '我对他人的兴趣没有减少。',
      '我对他人的兴趣比以前少了。',
      '我对他人几乎失去了兴趣。',
      '我对他人完全失去了兴趣。',
    ],
    [
      '我仍然能像以前一样做决定。',
      '我比以前更常拖延做决定。',
      '我在做决定方面比以前困难多了。',
      '我完全无法做决定了。',
    ],
    [
      '我不觉得自己看起来比以前差。',
      '我担心自己看起来变老或变得不吸引人。',
      '我觉得我的外貌发生了永久性的变化，让我变得不吸引人。',
      '我认为自己看起来很丑。',
    ],
    [
      '我工作能力和以前差不多。',
      '我需要额外努力才能开始做事。',
      '我必须非常努力才能做任何事。',
      '我根本无法工作。',
    ],
    [
      '我睡得跟平常一样好。',
      '我睡得没有以前好了。',
      '我比平时早醒1-2小时，且难以重新入睡。',
      '我比平时早醒好几个小时，且无法再次入睡。',
    ],
    [
      '我没有比平时更容易疲劳。',
      '我比以前更容易感到疲劳。',
      '我几乎做任何事都会感到疲劳。',
      '我太累了，什么都做不了。',
    ],
    [
      '我的食欲并没有比平时差。',
      '我的食欲不如以前。',
      '我现在的食欲差很多。',
      '我完全没有食欲了。',
    ],
    [
      '最近我几乎没有减重，或者根本没有减重。',
      '我减了超过五磅的体重。',
      '我减了超过十磅的体重。',
      '我减了超过十五磅的体重。',
    ],
    [
      '我对健康的担忧没有增加。',
      '我担心身体上的问题，比如疼痛、胃不适或便秘。',
      '我非常担心身体问题，几乎无法专注于其他事情。',
      '我对身体问题非常担忧，完全无法专注于其他事情。',
    ],
    [
      '我没有注意到自己对性生活的兴趣有明显变化。',
      '我对性生活的兴趣比以前少了。',
      '我几乎对性生活没有兴趣了。',
      '我完全对性生活失去了兴趣。',
    ],
  ];

  const watchSumValues = () => {
    const values = titles.map((_, i) =>
      watch(`content[${i}]`) ? Number(watch(`content[${i}]`)) : 0
    );
    let sum = sumValues(values);

    setValue('sum', sum);
    return sum;
  };

  return (
    <Fragment>
      {titles.map((title, idx) => (
        <>
          <SectionTitle title={title} />
          <Grid item xs={12}>
            <RadioGroup
              name={title}
              defaultValue={Number(getValues(`content[${idx}]`))}
            >
              <Table aria-label="simple table">
                <TableBody>
                  {answers[idx].map((answer, i) => {
                    return (
                      <TableRow key={answer}>
                        <TableCell sx={{ width: '80%' }}>{answer}</TableCell>
                        <TableCell sx={{ width: '10%' }}>{`${i}`}</TableCell>
                        <TableCell>
                          <Radio
                            disabled={disabled}
                            name={title}
                            value={i}
                            sx={{ height: '44px' }}
                            onChange={() => setValue(`content[${idx}]`, i)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </RadioGroup>
          </Grid>
        </>
      ))}

      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            总分 : {watchSumValues()} point
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.main}` }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                0-10
              </Box>
              : 这些起伏被认为是正常的
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                11-16
              </Box>
              : 轻度情绪障碍
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                17-20
              </Box>
              : 临界临床抑郁症
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                21-30
              </Box>
              : 中度抑郁症
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                31-40
              </Box>
              : 严重抑郁症
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                over 40
              </Box>
              : 极度抑郁症
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default BDIContents;
